import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
    Estados_Habitaciones,
    Tarifa,
    useCambiar_EstadoMutation,
    useTarifaByIdLazyQuery,
} from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { useDate } from "src/shared/hooks/useDate"
import useSnackbar from "src/shared/hooks/useSnackbar"
import { toggleRoomDetailsDrawer } from "src/store/navigation/navigationSlice"
import { VentaHabitacionCase } from "../VentaHabitacionCase.types"

// Check in de una habitación en venta en línea, la renta ya existe y solo se cambia el estado a ocupada.
// La renta llega con la forma de una reserva y sus valores no se pueden modificar
const useVentaEnLineaCase = (): VentaHabitacionCase => {
    const { habitacion_id = "" } = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { hotel_id, usuario_id } = useProfile()
    const { localDateToUTCString } = useDate()
    const { showSnackbar } = useSnackbar()
    const [getTarifaById] = useTarifaByIdLazyQuery()
    const [cambiarEstado] = useCambiar_EstadoMutation()

    const reserva = location?.state?.reservaSeleccionada

    return {
        reserva,
        codigoReserva: reserva?.folio ? `ER-${reserva.folio}` : undefined,
        // La tarifa de la venta en línea puede no estar visible para venta en mostrador, se consulta por su id
        cargarTarifas: () =>
            getTarifaById({
                variables: {
                    hotel_id,
                    tarifa_id: reserva?.tarifa_id,
                },
            }).then((t) => (t.data?.tarifas || []) as Tarifa[]),
        getEasyRewardsId: () => reserva?.easyrewards_id || null,
        // la tarifa ya está fijada por la renta
        validarTarifaPorFecha: false,
        camposBloqueados: { tipo: true, hospedajesExtra: true, earlyCheckIn: true, personas: true, nombre: true },
        conservarExtrasDeReserva: true,
        // La renta ya está pagada, solo se puede abonar a easyrewards
        getSeccionPago: () => "abonar",
        onSubmit: async (data, { habitacion, getCurrentDate }) => {
            await cambiarEstado({
                variables: {
                    actualizar_habitacion_estado_input: {
                        estado: Estados_Habitaciones.Ocupada,
                        fecha_estado: localDateToUTCString(getCurrentDate()),
                        habitacion_id,
                        easyrewards_id: data.abonarInput?.number?.trim() || undefined,
                        usuario_id,
                        hotel_id,
                        ...(data.matricula
                            ? {
                                renta_id: reserva?.renta_id,
                                vehiculo: {
                                    modelo: data.modelo as string,
                                    matricula: data.matricula,
                                    color: data.color as string,
                                    marca: data.marca as string,
                                },
                            }
                            : {}),
                    },
                },
            })
                .then(() => {
                    showSnackbar({
                        title: "Check in realizado",
                        text: `La habitación **${habitacion?.habitacion.tipo_habitacion?.nombre} ${habitacion?.habitacion.numero_habitacion}** pasó de **venta en línea** a **ocupada.**`,
                        status: "success",
                    })
                    dispatch(toggleRoomDetailsDrawer(false))
                    navigate("/u")
                })
                .catch(() => {
                    showSnackbar({
                        title: "Error al hacer check in",
                        text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente",
                        status: "error",
                    })
                })
        },
    }
}

export default useVentaEnLineaCase
